import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=9427c580&"
import script from "./LoginForm.vue?vue&type=script&lang=ts&"
export * from "./LoginForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports